import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { ExtractCleanUrlQuery, ExtractCleanUrlQueryVariables } from './__generated__/ExtractCleanUrlQuery';

const EXTRACT_CLEAN_URL_QUERY = gql`
  query ExtractCleanUrlQuery($url: String!) {
    extractCleanUrl(url: $url)
  }
`;

export const useExtractCleanUrlLazyQuery = () => {
  return useLazyQuery<ExtractCleanUrlQuery, ExtractCleanUrlQueryVariables>(EXTRACT_CLEAN_URL_QUERY, {
    client: kmsClient
  });
};
